module.exports = __webpack_public_path__ + "media/images/front/treatment_support/img_popup_thinking-bf1eeb0dca23450513b9dcf7bbec7471.png";